import React, {memo} from 'react';
import {CheckIcon, XIcon} from 'lucide-react';
import {
  Box,
  Typography,
  Snackbar,
  SnackbarContent,
  Stack,
  IconButton,
} from '@mui/material';
import PropTypes from 'prop-types';

const severityMap = {
  error: {
    title: 'Something went wrong',
    color: '#E85835',
    Icon: <XIcon color="white" size={12} />,
  },
  success: {
    title: 'Account line classification changed',
    color: '#7FC407',
    Icon: <CheckIcon color="white" size={12} />,
  },
};

function ReclassifySnackbarComp({message, severity, onClose, open}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
    >
      <SnackbarContent
        sx={{
          color: '#0F1E24 !important',
          backgroundColor: 'white',
          minWidth: '100% !important',
          maxWidth: '350px',
        }}
        message={
          <Stack width="100%">
            <Stack
              width="100%"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              pb={1}
            >
              <Stack
                direction="row"
                alignItems="center"
                pr={4}
                gap={1}
                width="100%"
              >
                {severityMap[severity] && (
                  <>
                    <Box
                      sx={{
                        backgroundColor: `${severityMap[severity].color} !important`,
                        borderRadius: '100%',
                        width: 20,
                        height: 20,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {severityMap[severity].Icon}
                    </Box>
                    <Typography fontWeight={500} fontSize={14}>
                      {severityMap[severity].title}
                    </Typography>
                  </>
                )}
              </Stack>
              <IconButton size="small" onClick={onClose}>
                <XIcon size={16} />
              </IconButton>
            </Stack>
            <Typography whiteSpace="wrap" fontSize={12} pl={3.5}>
              {message}
            </Typography>
          </Stack>
        }
      />
    </Snackbar>
  );
}

ReclassifySnackbarComp.propTypes = {
  message: PropTypes.string,
  severity: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export const ReclassifySnackbar = memo(ReclassifySnackbarComp);
